import { render, staticRenderFns } from "./CommonBadgesListRemove.vue?vue&type=template&id=5e0ded12"
import script from "./CommonBadgesListRemove.vue?vue&type=script&lang=js"
export * from "./CommonBadgesListRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports